import { render, staticRenderFns } from "./myfooter.vue?vue&type=template&id=5590663f&"
import script from "./myfooter.vue?vue&type=script&lang=js&"
export * from "./myfooter.vue?vue&type=script&lang=js&"
import style0 from "./myfooter.vue?vue&type=style&index=0&id=5590663f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports